import InitiativeDetail from '../../components/light/initiative/InitiativeDetail';

const initiative = {
  title: 'Nigeria School Uniform Equity Initiative (NSUEI)',
  category: 'Education',
  year: '2019',
  location: 'Lagos & Ogun States',
  heroImage: '/light/assets/imgs/spob/initiative-2.jpg',
  need: {
    headline:
      'Many school-age children in low-income households cannot attend school due to the inability to afford mandatory uniforms.',
    body: "In numerous public schools across Nigeria, wearing a school uniform is a stated admission or attendance requirement. For families living below the poverty line, the cost of even one set of uniform can represent a week's income. Children excluded for this reason fall behind academically and are more vulnerable to child labour and early marriage. SPOB identified this preventable barrier and launched NSUEI to address it directly.",
  },
  approach: {
    headline:
      'SPOB partners with public schools and local tailors to provide uniform sets to pupils who need them most.',
    body: 'Through NSUEI, SPOB identifies eligible pupils in partner schools via teachers and community referrals, then coordinates with local tailors to produce and distribute full uniform sets. Back-to-school drives are held each September and January. The programme also donates school bags and stationery bundles to ensure children are fully equipped, removing every barrier to dignified attendance.',
  },
  stats: [
    { number: '5,000+', label: 'Uniforms Distributed' },
    { number: '30', label: 'Partner Schools' },
    { number: '18', label: 'LGAs Covered' },
  ],
  next: {
    title: 'Foundational Learning & Academic Support Initiative (FLASI)',
    href: '/light/initiative-flasi',
  },
};

export default function InitiativeNSUEI() {
  return <InitiativeDetail initiative={initiative} />;
}
